import {
  geoJsonFile,
  scriptInjectedFn,
  dataFile,
  // dataFilePath,
  // getDataFileEndpoint
} from '../config';
import { liveLoaderProps } from '../components/live-loader';

export const getWaterData = () => {
  const url = scriptInjectedFn.getDataFileEndpoint({
    ...liveLoaderProps,
    dataset: dataFile,
    publicUrl: `${process.env.PUBLIC_URL}/data`,
  });

  return fetch(url).then((response) => response.json());
};

export const getQldRegionGeo = () => {
  const url = scriptInjectedFn.getDataFileEndpoint({
    ...liveLoaderProps,
    dataset: geoJsonFile,
    publicUrl: `${process.env.PUBLIC_URL}/data`,
  });
  return fetch(url).then((response) => response.json());
};



// WEBPACK FOOTER //
// ./src/api/index.js